export default "__VITE_ASSET__BhsrqxXG__"